import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, TextField, CircularProgress } from '@mui/material';
import { FormControlLabel, Checkbox, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { authenticateUser } from './apiService';
import cdLogo from './Pics/CD Logo1.png';

const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    width: '350px',
    maxWidth: 'none',
    borderRadius: '20px',
  },
}));

const LoginPopup = ({ open, onClose, onLogin, isLoading }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [rememberMe, setRememberMe] = useState(false);

  useEffect(() => {
    if (open) {
      setUsername('');
      setPassword('');
      setError('');
      setRememberMe(false);
    }
  }, [open]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username || !password) {
      setError('Please enter both username and password');
      return;
    }
    setError('');
    try {
      const userData = await authenticateUser(username, password);
      const success = await onLogin(userData, rememberMe);
      if (!success) {
        setError('Failed to initialize application');
      }
    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <StyledDialog
      open={open}
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          onClose();
        }
      }}
      className="login-dialog"
      disableEscapeKeyDown
    >
      <DialogContent style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100%', padding: '18px' }}>
        <Box display="flex" justifyContent="center" mb={2}>
          <img src={cdLogo} alt="CD Logo" style={{ width: '200px', height: 'auto' }} />
        </Box>
        <Box mb={2} display="flex" alignItems="center" justifyContent="center">
          <DialogContentText>
            <strong>Login To Concession Product Central</strong>
          </DialogContentText>
        </Box>
        <form id="loginForm" onSubmit={handleSubmit} style={{ width: '100%', maxWidth: '300px' }}>
          <TextField
            autoFocus
            margin="dense"
            id="username"
            label="Username"
            type="text"
            fullWidth
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            error={!!error}
            InputProps={{ style: { borderColor: error ? 'red' : '' } }}
          />
          <TextField
            margin="dense"
            id="password"
            label="Password"
            type="password"
            fullWidth
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            error={!!error}
            InputProps={{ style: { borderColor: error ? 'red' : '' } }}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
                color="primary"
              />
            }
            label="Remember me"
            style={{ marginTop: '8px' }}
          />
          {error && (
            <Box mt={1} color="error.main" textAlign="center">
              {error}
            </Box>
          )}
          <Box mt={2} mb={2} display="flex" justifyContent="center">
            <Button 
              type="submit" 
              form="loginForm" 
              color="primary" 
              disabled={isLoading} 
              style={{ backgroundColor: '#1976d2', color: 'white', width: '130px' }}
            >
              {isLoading ? (
                <CircularProgress size={24} color="inherit" />
              ) : 'Login'}
            </Button>
          </Box>
        </form>
      </DialogContent>
    </StyledDialog>
  );
};

export default LoginPopup;
